import React, { useState } from 'react';
import { useSelector, useDispatch } from "react-redux";
import { Box } from '@mui/material';
import LicenceCriteriaTable from '../../components/LicenceCriteriaTable';
import DetailedCriteria from '../DetailedCriteria';
import { getLicenceCriteria, getLicenceSaCriteria } from '../../api/licence';
import { setLicenceCriteria, setSelectedLicenceCriteria } from '../../redux/reducers/licence';
import PhaseHeader from '../PhaseHeader';
import { useLocation } from 'react-router';
import { licenceCriteriaActionsRegex, licenceCriteriaEvidencesRegex, licenceCriteriaRegex, licenceCriterionRegex, licenceSelectedCriteriaActionsRegex, licenceSelectedStandardsRegex, licenceStandardsRegex } from '../../common/StaticExports';

const LicenceHome = () => {
    const dispatch = useDispatch();
    const location = useLocation();
    const clubDetails = useSelector((state:any) => state.clubDetails);
    const selectedLicenceCriteria = useSelector((state: any) => state.licence.selectedLicenceCriteria);
    const licenceCriteria = useSelector((state: any) => state.licence.licenceCriteria);  
    const isAdmin = useSelector((state:any) => state.common.isAdmin);

    const fetchLicenceCriteria = async () => {
        try {
            const response = isAdmin ? 
            await getLicenceCriteria({clubId: clubDetails.id}) :
            await getLicenceSaCriteria({clubId: clubDetails.id});
            dispatch(setLicenceCriteria(response));
            manageSelectedCriteria(response);
        } catch {
            
        }
    };

    const manageSelectedCriteria = (licenceCriteriaResponse:any) => {
        if (!selectedLicenceCriteria && 
            (licenceCriterionRegex.test(location.pathname) ||
            licenceStandardsRegex.test(location.pathname) ||
            licenceCriteriaEvidencesRegex.test(location.pathname) ||
            licenceCriteriaActionsRegex.test(location.pathname) ||
            licenceSelectedStandardsRegex.test(location.pathname)||
            licenceSelectedCriteriaActionsRegex.test(location.pathname))) {
            var tempCriteriaId = location.pathname.split('/')[3];
            var tempSelectedCriteria = licenceCriteriaResponse?.find((d:any) => d.id == tempCriteriaId);
            dispatch(setSelectedLicenceCriteria(tempSelectedCriteria));
        }
    }

    React.useEffect(() => {
        (!licenceCriteria &&
        (licenceCriteriaRegex.test(location.pathname) || 
        licenceCriterionRegex.test(location.pathname) ||
        licenceStandardsRegex.test(location.pathname) ||
        licenceCriteriaActionsRegex.test(location.pathname) ||
        licenceCriteriaEvidencesRegex.test(location.pathname) ||
        licenceSelectedStandardsRegex.test(location.pathname)||
        licenceSelectedCriteriaActionsRegex.test(location.pathname))) &&
        fetchLicenceCriteria();

        licenceCriteria &&
        manageSelectedCriteria(licenceCriteria);
        
    }, [clubDetails, location, licenceCriteria]);    

    return(
        <React.Fragment>
            <Box className={'contentSpacing'} sx={{ mt: 6, height: '100%' }}>
                <PhaseHeader module={'LICENCE'} />
                <Box
                sx={selectedLicenceCriteria && Object.keys(selectedLicenceCriteria)?.length ? {display: "flex", height: '100%'} : { height: '100%' }}>
                    <LicenceCriteriaTable data={licenceCriteria}
                    licenceCriteria={!selectedLicenceCriteria || Object.keys(selectedLicenceCriteria).length === 0}
                    selectedLicenceCriteria={selectedLicenceCriteria}
                    triggerFetchLicenceCriteria={fetchLicenceCriteria}/>
                    {(selectedLicenceCriteria && Object.keys(selectedLicenceCriteria).length > 0) && <DetailedCriteria criteria={selectedLicenceCriteria} module={'licence'}/>}
                </Box>
            </Box>
        </React.Fragment>
    )
}

export default LicenceHome;